/* eslint-disable react/no-did-update-set-state */
import PropTypes from 'prop-types';
import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import Post from '../PostsTable/PostCell/PostCell.Container';
import PostNavigation from '../PostNavigation/PostNavigation.container';
import SchedulePostDialog from '../SchedulePostDialog';
import TextButton from '../../../common/Buttons/TextButton';
import style from './style';

class ClassRoomPost extends React.Component {
  constructor(props) {
    super(props);

    this.loadPost = this.loadPost.bind(this);

    this.state = {
      isLoading: false,
      postViewEventSent: false,
    };
  }

  componentWillMount() {
    this.loadPost();
  }

  componentDidMount() {
    this.updateDocumentTitle();
  }

  componentDidUpdate(prevProps) {
    const { post, postId, spaceId, sendViewPostAnalytic } = this.props;
    const { postViewEventSent } = this.state;

    if (prevProps.postId !== postId) {
      this.loadPost();

      // Make sure we send a post view event again if the postId changes
      this.setState({ postViewEventSent: false });
    }

    this.updateDocumentTitle();

    // Handle sending the POST_VIEW analytic event
    if (!postViewEventSent && postId && post && spaceId) {
      sendViewPostAnalytic({ postId, post, activeClassroom: spaceId });
      this.setState({ postViewEventSent: true });
    }
  }

  updateDocumentTitle() {
    const { spaceName } = this.props;
    const space = spaceName ? `${spaceName} - ` : '';
    document.title = `Post - ${space}Aula`;
  }

  async loadPost() {
    const { spaceId, fetchPost, postId } = this.props;
    this.setState({ isLoading: true });
    if (spaceId) {
      await fetchPost(postId);
      this.setState({
        isLoading: false,
      });
    } else {
      setTimeout(this.loadPost, 300);
    }
  }

  render() {
    const {
      post,
      scheduledPostCount,
      nextScheduledPostId,
      openScheduledPosts,
    } = this.props;
    const { isLoading } = this.state;

    if (isLoading || !post) {
      return <div />;
    }

    const scheduledRow =
      nextScheduledPostId === post.objectId ? (
        <div style={style.scheduledRow}>
          <div style={style.nextScheduledPost}>Next scheduled post</div>
          <div>
            <TextButton
              label={
                scheduledPostCount > 1
                  ? `View ${scheduledPostCount} scheduled posts`
                  : 'View 1 scheduled post'
              }
              onClick={openScheduledPosts}
            />
          </div>
        </div>
      ) : null;

    return (
      <div style={style.container}>
        <Scrollbars autoHide>
          <PostNavigation style={style.navigation} />
          <div style={style.parentWrapper}>
            <div style={style.wrapper}>
              {scheduledRow}
              <Post
                key={post.objectId}
                post={post}
                classId={post.classRoom}
                showComments
              />
            </div>
          </div>
        </Scrollbars>
        <SchedulePostDialog />
      </div>
    );
  }
}

ClassRoomPost.propTypes = {
  spaceId: PropTypes.string,
  spaceName: PropTypes.string,
  fetchPost: PropTypes.func.isRequired,
  postId: PropTypes.string.isRequired,
  post: PropTypes.shape({
    objectId: PropTypes.string,
    classRoom: PropTypes.string,
  }),
  scheduledPostCount: PropTypes.number.isRequired,
  nextScheduledPostId: PropTypes.string,
  openScheduledPosts: PropTypes.func.isRequired,
  sendViewPostAnalytic: PropTypes.func.isRequired,
};

ClassRoomPost.defaultProps = {
  spaceName: '',
  spaceId: null,
  post: null,
  nextScheduledPostId: null,
};

export default ClassRoomPost;
